import {z} from 'zod'

export const HostMediaSchema = z.object({
    id: z.number(),
    user_id: z.number(),
    url: z.string().nullable(),
    path_location: z.string().nullable(),
    main: z.boolean().nullable().optional(),
    created_at: z.string(),
    under_validation: z.boolean(),
    status: z.string().optional(),
    declined_reason: z.union([z.string(), z.null()]).optional()
})

export const HostMediaResponseSchema = z.array(HostMediaSchema)

export const MediaSchema = z.object({
    id: z.number(),
    userId: z.number(),
    pathLocation: z.string(),
    blurredPathLocation: z.string(),
    blurHash: z.string(),
    url: z.string(),
    blurredUrl: z.string(),
    underValidation: z.boolean()
})

export const PhotoSchema = MediaSchema.extend({
    main: z.boolean(),
    optimizedUrls: z.record(z.string(), z.string())
})

export const VideoSchema = MediaSchema.extend({
    isProcessed: z.number(),
    createdAt: z.string(),
    optimizedUrl: z.string()
})

export const PhotoListSchema = z.object({
    photos: z.array(PhotoSchema),
    photosCount: z.number()
})

export const VideoListSchema = z.object({
    videos: z.array(VideoSchema),
    videosCount: z.number()
})
